(function () {
  'use strict';

  const TRIGGER_SELECTOR = [
    '[data-sms-opt-in-trigger]',
    'a[href="#sms-opt-in"]',
    'a[href="#sms-opt-in-modal"]',
    'a[href="sms:+18885285923"]',
    'a[href="tel:+18885285923"]',
  ].join(',');

  if (customElements.get('sms-opt-in-modal')) return;

  customElements.define(
    'sms-opt-in-modal',
    class SmsOptInModal extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.checkbox = this.querySelector('[data-sms-opt-in-checkbox]');
        this.submitButton = this.querySelector('[data-sms-opt-in-submit]');
        this.smsUrl = this.dataset.smsUrl || 'sms:+18885285923';
        this.activeTrigger = null;

        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onModalClick = this.onModalClick.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);

        document.addEventListener('click', this.onDocumentClick);
        this.dialog.addEventListener('click', this.onModalClick);
        this.dialog.addEventListener('close', this.onClose);
        this.checkbox.addEventListener('change', this.onCheckboxChange);
        this.submitButton.addEventListener('click', this.onSubmit);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        this.dialog.removeEventListener('click', this.onModalClick);
        this.dialog.removeEventListener('close', this.onClose);
        this.checkbox.removeEventListener('change', this.onCheckboxChange);
        this.submitButton.removeEventListener('click', this.onSubmit);
      }

      onDocumentClick(event) {
        const trigger = event.target.closest(TRIGGER_SELECTOR);
        if (!trigger || this.contains(trigger)) return;

        event.preventDefault();
        this.open(trigger);
      }

      onModalClick(event) {
        if (event.target === this.dialog || event.target.closest('[data-sms-opt-in-close]')) {
          event.preventDefault();
          this.close();
        }
      }

      onCheckboxChange() {
        this.submitButton.disabled = !this.checkbox.checked;
      }

      onSubmit() {
        if (!this.checkbox.checked) return;
        window.location.href = this.smsUrl;
      }

      onClose() {
        if (this.activeTrigger) {
          this.activeTrigger.focus();
          this.activeTrigger = null;
        }
      }

      open(trigger) {
        this.activeTrigger = trigger;
        this.checkbox.checked = false;
        this.submitButton.disabled = true;

        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }

        this.checkbox.focus();
      }

      close() {
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
          this.onClose();
        }
      }
    }
  );
})();
